<script setup>
import { ref, watch } from 'vue';

import i18n from './BlockInteraction.i18n.js';

const props = defineProps({
    requestInProgress: {
        type: Boolean,
        required: true,
    },
    delay: {
        type: Number,
        required: false,
        default: 1000,
    },
    waitingText: {
        type: String,
        required: false,
        default: () => i18n.performingAction(),
    },
});

const isSlow = ref(false);
const timerId = ref(null);

watch(() => props.requestInProgress, (value) => {
    if (value) {
        isSlow.value = false;
        timerId.value = setTimeout(() => isSlow.value = true, props.delay);
    } else {
        if (timerId.value) {
            clearTimeout(timerId.value);
            timerId.value = null;
        }
    }
});
</script>

<template>
    <div
        :class="['cv-edit-block-interaction', { 'cv-edit-block-interaction--active': requestInProgress, 'cv-edit-block-interaction--slow': isSlow }]"
        @click.prevent
    >
        <span v-if="isSlow" class="d-flex align-items-center">
            <div class="spinner-grow mr-3" role="status">
                <span class="sr-only">{{ waitingText }}</span>
            </div>
            {{ waitingText }}
        </span>
    </div>
</template>
